import React from 'react'
import logo from './logonab2.png'
class Header extends React.Component
{
render()
{
    const logorow={
        textAlign:"center"
    }
   
    return(
        <div style={logorow}>
            <img src={logo} alt="Customer Survey"/>
        </div>
    )
}

}

export default Header